import React, { Component } from 'react';
import { Link } from 'react-router';

class Header extends Component {

  render() {
    return (
      <div className={"masthead " + this.props.theme}>
        <div className="container">
          <h3 className="masthead-title">
            <Link to="/home" >Kim Kaycee Ong Muslim</Link>
            <small>Full Stack Developer based in Philippines</small>
          </h3>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/Header.js